module.exports = __webpack_public_path__ + "static/media/cmu_logo.2fe8800e.svg";